import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { UntypedFormControl, UntypedFormGroup, UntypedFormArray, UntypedFormBuilder } from '@angular/forms';
import { Location } from '@angular/common';

import { ModalComponent } from '../../modal/modal.component';
import { CustomerRemarkPluginService } from './customerremark-plugin.service';
import { BaseModalPageComponent } from '../../base-modal.component';
import { ConfirmComponent } from '../../modal/confirm.component';

import * as _ from 'lodash';

@Component({
    selector: 'customerremark-edit',
    templateUrl: './customerremark-edit.component.html',
    standalone: false
})
export class CustomerRemarkEditPageComponent extends BaseModalPageComponent implements OnInit {
  inspectionId: string;
  pointId: string;
  pluginId: string;
  plugin: any;
  public currentItem: any;
  editForm: UntypedFormGroup;
  @ViewChild('typesModal', { static: true })
  typeModal: ModalComponent;
  @ViewChild('menuModal', { static: true })
  menuModal: ModalComponent;
  @ViewChild('deleteConfirm', { static: true })
  deleteConfirm: ConfirmComponent;
  public types: any;
  public processing = false;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private service: CustomerRemarkPluginService,
    location: Location,
    private cdRef: ChangeDetectorRef,
    private fb: UntypedFormBuilder
  ) {
    super(location);
  }

  initRoute(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      const id = params['inspectionId'];
      if (id == null) this.router.navigate([this.inspectionsRoute]);

      this.inspectionId = id;

      const pointId = params['pointId'];
      if (pointId == null) this.router.navigate([this.inspectionsRoute, this.inspectionId]);

      this.pointId = pointId;

      const pluginId = params['pluginId'];
      if (pluginId == null) this.goToBack();

      this.pluginId = pluginId;

      this.initData();
    });
  }

  save(model: any) {
    this.processing = true;
    this.service.updateComment(this.inspectionId, this.pointId, this.pluginId, model.remarks).subscribe((res) => {
      this.processing = false;
      this.goToBack();
    });
  }

  cancel() {
    this.goToBack();
  }

  ngOnInit() {
    this.initRoute();
  }

  initData() {
    this.types = this.service.getTypes();

    this.service.getPlugin(this.inspectionId, this.pluginId).subscribe((data) => {
      this.plugin = data;
      this.initForm();
      this.cdRef.detectChanges();
    });
  }

  public openTypesSelector(selectedIndex: number, i: number): void {
    this.openSelector(this.typeModal, this.types, selectedIndex);
    const control = <UntypedFormArray>this.editForm.controls['remarks'];
    this.currentItem = control.controls[i];
  }

  public selectTypesMenu(item: any) {
    const selectedIndex = this.currentItem.controls['Type'].value === item.selectedIndex ? -1 : item.selectedIndex;
    this.currentItem.controls['Type'].setValue(selectedIndex);
  }

  public onClose(e: any) {
    this.currentItem.controls['Type'].markAsTouched();
  }

  add() {
    const control = <UntypedFormArray>this.editForm.controls['remarks'];
    control.push(this.initRemark());
  }

  initForm() {
    this.editForm = this.fb.group({
      remarks: this.fb.array([])
    });

    const control = <UntypedFormArray>this.editForm.controls['remarks'];
    _.forEach(this.plugin.config.Remarks, (el) => {
      control.push(this.initRemark(el));
    });
  }

  get formData() {
    return <UntypedFormArray>this.editForm.controls['remarks'];
  }

  initRemark(el?: any) {
    const regex = new RegExp(/<br\s*[\/]?>/gi);

    return this.fb.group({
      Comment: new UntypedFormControl(el && el.Comment ? el.Comment.replace(regex, '\n') : ''),
      Type: [el && !isNaN(parseInt(el.Type)) ? parseInt(el.Type) : -1]
    });
  }

  remove(i: number) {
    const control = <UntypedFormArray>this.editForm.controls['remarks'];
    control.removeAt(i);
  }

  public selectMenu(item: any) {
    switch (item) {
      case 1:
        this.openDeleteConfirm();
        break;
      case 10:
        this.gotoEditJsonPage();
        break;
      case 11:
        this.gotoEditPage();
        break;
      default:
    }
  }

  gotoEditJsonPage() {
    return this.router.navigate([
      this.inspectionsRoute,
      this.inspectionId,
      'points',
      this.pointId ? this.pointId : -1,
      'plugins',
      this.pluginId,
      'editjson'
    ]);
  }

  gotoEditPage() {
    return this.router.navigate([
      this.inspectionsRoute,
      this.inspectionId,
      'points',
      this.pointId ? this.pointId : -1,
      'plugins',
      this.pluginId,
      'edit'
    ]);
  }

  openDeleteConfirm() {
    this.deleteConfirm.open();
  }

  deletePlugin(e: any) {
    this.service.deletePlugin(this.inspectionId, this.pointId, this.pluginId).subscribe((success: boolean) => {
      if (success) {
        this.goToBack();
      }
    });
  }
}
